import Vue from 'vue'
import Vuetify from 'vuetify/lib'
// import i18n from '@/i18n'
import '@/sass/overrides.sass'
import fa from 'vuetify/es5/locale/fa'

Vue.use(Vuetify)

const theme = {
  primary: '#16293F',
  secondary: '#9C27b0',
  accent: '#9C27b0',
  info: '#16293F',
}

export default new Vuetify({
  rtl: true,
  lang: {
    // t: (key, ...params) => i18n.t(key, params),
    locales: { fa },
    current: 'fa',
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
})
